<div class="backdrop" *ngIf="showBackdrop"></div>
<div class="{{ labelAlign }}"
    [ngClass]="{ 'container-label': label, 'backdrop-spinner': showBackdrop }">
    <!-- Loading Spinner -->
    <div *ngIf="!useWavingSpinner && showSpinner"
        class="loading-spinner"
        [ngClass]="size"
        [@spinnerExitOut]>
    </div>
    <!-- DCL Waving Page Loader -->
    <div
        *ngIf="useWavingSpinner && showSpinner"
        class="waving-spinner">
    </div>
    <div class="label"
        *ngIf="showSpinner && label"
        [ngClass]="{ 'small-label': size === 'small' }"
        aria-hidden="true">
        {{ label | translate }}
    </div>
    <div *ngIf="showSpinner && ariaLabel"
        class="sr-only"
        [attr.role]="!!alertRole ? 'alert' : null">
        {{ ariaLabel | translate }}
    </div>
</div>
